import { Component, Input, Output, OnInit, EventEmitter, ViewChild, ChangeDetectorRef, Inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSliderModule } from '@angular/material/slider';
import { MatIcon } from '@angular/material/icon';
import { library, IconPrefix, icon, IconLookup, IconName } from '@fortawesome/fontawesome-svg-core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'captcha',
  templateUrl: 'Captcha.component.html',
  styleUrls: ['Captcha.component.css', '../../styles.scss'],
  imports: [FormsModule, NgClass],
  providers: [MatSliderModule, MatIcon],
  exportAs: 'ngModel'
})

export class CaptchaComponent {
  captchaType: number = 0;
  captchaData: any;
  sliderValue: number = 0;
  dragItems: Array<any> = [];
  selectedItem: any = null;
  selectedDragItem: any = null;
  captchaDataLoaded = false;

  icons = [
    'fa-house', 'fa-car', 'fa-tree', 'fa-bicycle', 'fa-plane', 'fa-ship',
    'fa-bus', 'fa-train', 'fa-motorcycle', 'fa-truck', 'fa-rocket', 'fa-subway',
    'fa-helicopter', 'fa-anchor', 'fa-ambulance', 'fa-fighter-jet', 'fa-taxi',
    'fa-shopping-cart', 'fa-dog', 'fa-cat', 'fa-fish', 'fa-horse', 'fa-paw',
    'fa-dragon', 'fa-crow', 'fa-apple-alt', 'fa-lemon', 'fa-carrot', 'fa-hamburger',
    'fa-pizza-slice', 'fa-ice-cream', 'fa-candy-cane', 'fa-birthday-cake', 'fa-cookie',
    'fa-coffee', 'fa-mug-hot', 
    'fa-mountain', 'fa-sun', 'fa-moon', 'fa-cloud',
    'fa-rainbow', 'fa-snowflake', 'fa-fire', 'fa-lightning-bolt', 'fa-wind',
    'fa-water'
  ];

  constructor(
    public dialogRef: MatDialogRef<CaptchaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.generateCaptcha();    
  }

  generateCaptcha(): void {
    this.captchaType = Math.floor(Math.random() * 3) + 1;
    switch (this.captchaType) {
      case 1:
        this.setupSlideCaptcha();
        break;
      case 2:
        this.setupDragCaptcha();
        break;
      case 3:
        this.setupRotateCaptcha();
        break;
    }
  }

  setupSlideCaptcha(): void {
    var targetStart = (Math.random() * 80) * 2; // Random start between 0 and 80

    while (targetStart < 40) {
      targetStart = (Math.random() * 80) * 2;
    }

    const targetWidth = 40;
    this.captchaData = {
      targetRangeStart: targetStart,
      targetRangeWidth: targetWidth
    };
    this.sliderValue = 0;
    while (this.collision()) {
      this.captchaData.targetRangeStart = (Math.random() * 80) * 2;
    }
  }

  onSliderChange(event: any): void {
    if (this.collision()) {
      console.log('close');
      this.closeDialog(true);
    }
  }

  collision() {
    const targetEnd = this.captchaData.targetRangeStart + 30;// + this.captchaData.targetRangeWidth;
    var slider = this.sliderValue * 2;
    if (slider >= this.captchaData.targetRangeStart + 6 && slider <= targetEnd - 6) {
      return true;
    }
    return false;
  }

  closeDialog(result: boolean): void {
    this.dialogRef.close(result);
  }


  setupDragCaptcha(): void {
    this.captchaDataLoaded = false;
    this.dragItems = this.shuffleArray(this.icons).slice(0, 3);
    const randomIndex = Math.floor(Math.random() * this.dragItems.length);
    this.selectedItem = this.dragItems[randomIndex];
    // Convert the selected icon to an image
    this.convertIconToSVG(this.selectedItem).then(imageDataUrl => {
      this.captchaData = {
        dragItem: this.selectedItem,
        dragItemImage: imageDataUrl,
        dragItems: this.dragItems,
      };
      this.captchaDataLoaded = true;
    });
  }

  convertIconToSVG(iconClass: string): Promise<string> {
    return new Promise((resolve) => {      
      const svgElement = icon(<IconLookup>{ prefix: <IconPrefix>'fas', iconName: <IconName>(iconClass.split('-').pop()) }).node[0] as SVGElement;
      const svgString = new XMLSerializer().serializeToString(svgElement);
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const image = new Image();
      const svg = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
      const url = URL.createObjectURL(svg);

      image.onload = () => {
        canvas.width = image.width;
        canvas.height = image.height;
        ctx?.drawImage(image, 0, 0);
        URL.revokeObjectURL(url);
        resolve(canvas.toDataURL());
      };

      image.src = url;
    });
  }

  shuffleArray(array: Array<any>): Array<any> {
    return array.sort(() => Math.random() - 0.5);
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    if (this.selectedItem === this.selectedDragItem) {
      this.closeDialog(true);
    }
  }

  allowDrop(event: DragEvent): void {
    event.preventDefault();
  }

  onDragStart(event: DragEvent, icon: string): void {
    this.selectedDragItem = icon;
  }

  onKeydownDragStart(event: KeyboardEvent, icon: string): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.selectedDragItem = icon;
      this.announce(`Selected ${icon}`);
    }
  }

  onKeydownDrop(event: KeyboardEvent): void {
    if ((event.key === 'Enter' || event.key === ' ') && this.selectedItem) {
      event.preventDefault();
      console.log(this.selectedItem);
      if (this.selectedItem == this.selectedDragItem) {
        this.closeDialog(true);
      }
    }
  }

  announce(message: string): void {
    const liveRegion = document.getElementById('captcha-live-region');
    if (liveRegion) {
      liveRegion.textContent = ''; // Clear previous message
      setTimeout(() => {
        liveRegion.textContent = message;
      }, 100); // Slight delay to ensure screen readers notice the update
    }
  }

  setupRotateCaptcha(): void {
    const alphabet = 'ABCDEFGJKLNPQRSTUVY';
    const rotations = [90, 180, 270];

    this.captchaData = {
      letters: [
        { char: alphabet[Math.floor(Math.random() * alphabet.length)], rotationIndex: Math.floor(Math.random() * 3) },
        { char: alphabet[Math.floor(Math.random() * alphabet.length)], rotationIndex: Math.floor(Math.random() * 3) },
        { char: alphabet[Math.floor(Math.random() * alphabet.length)], rotationIndex: Math.floor(Math.random() * 3) }
      ]
    };
    this.captchaData.letters.forEach((letter : any) => {
      letter.rotation = rotations[letter.rotationIndex];
    });
    this.captchaDataLoaded = true;
  }

  rotateLetter(index: number): void {
    console.log('index', index);
    this.captchaData.letters[index].rotation = (this.captchaData.letters[index].rotation + 90) % 360;
    this.checkRotations();
  }

  checkRotations(): void {
    const allAligned = this.captchaData.letters.every((letter : any) => {
      console.log(letter.rotation);
      return letter.rotation === 0 || letter.rotation === 360
    });
    if (allAligned) {
      this.closeDialog(true);
    }
  }
}
